import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { useReturnsSettingsExperience } from "@redotech/redo-merchant-app-common/settings/use-returns-settings-experience";
import {
  legacySettingsPathForTab,
  RETURNS_SETTINGS_TAB_QUERY_PARAM,
} from "@redotech/redo-settings-common/flat-team-settings/returns/returns-settings-tab";
import { useNavigate, useSearchParams } from "react-router-dom";

/** Switches to the old pages, landing on the one the current tab replaced. */
export function useSwitchToLegacySettings(): () => void {
  const routes = useRequiredContext(MerchantRoutesContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const experience = useReturnsSettingsExperience();

  return useHandler(() => {
    const tab = searchParams.get(RETURNS_SETTINGS_TAB_QUERY_PARAM);
    experience.switchToLegacy();
    navigate(routes.getSettingsSubRoute(legacySettingsPathForTab(tab)));
  });
}
